<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      进销存数据统计
      <small>/进销存汇总</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">进销存汇总表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">商品名称:</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="可模糊查询出商品"
                          v-model="orderNo"
                        />
                      </div>
                      <label class="col-md-1 col-form-label">料号 :</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="可模糊查询出料号"
                          v-model="fuzzyRecom"
                        />
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">订单状态</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="datavalue"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                        </el-select>
                      </div>

                      <label class="col-md-2 col-form-label">时间:</label>
                      <div class="col-md-3">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                        ></el-date-picker>
                      </div>
                      <div class="col-md-2"></div>
                      <div class="col-md-1 LineSpacing">
                        <a class="btn btn-primary ButtonColor m-r-5">查询</a>
                      </div>
                    </div>
                    <div style="margin-bottom:15px;text-align:right;">
                      <a class="btn btn-primary ButtonColor m-r-5">导出表格</a>
                    </div>
                  </fieldset>
                </form>
                <!-- 03表格 -->
                <div >
                      <div class="grid-content bg-purple-dark">
                        <el-table :data="tableData" border style="width: 100%">
                          <el-table-column prop="id" label="序号" align="center"></el-table-column>
                          <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                          <el-table-column prop="address" label="料号" align="center"></el-table-column>
                          <el-table-column prop="address" label="条形码" align="center"></el-table-column>
                          <el-table-column prop="address" label="期初库存" align="center"></el-table-column>
                          <el-table-column label="本期入库" align="center">
                            <!--  prop="address"   本期入库-->
                              <template slot-scope="scope">
                                    <el-button type="text" plain size="small" @click = aaa(scope.row)> 数量【链接到进】</el-button>
                              </template>
                          
                          </el-table-column>
                          <el-table-column  label="本期出库" align="center">
                               <!--prop="address"  本期出库 -->
                                 <template slot-scope="scope">
                                    <el-button type="text" plain size="small" @click = bbb(scope.row)> 数量【链接到销售】</el-button>
                              </template>
                          </el-table-column>
                          <el-table-column prop="address" label="期末结余" align="center"> </el-table-column>
                        </el-table>
                      </div>
                </div>
                <!-- 04 -->
                <div class="bottom">
                  <div class="block">
                    <el-pagination
                      :current-page="currentPage4"
                      :page-sizes="[10, 20, 30, 40]"
                      :page-size="10"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="40"
                      background
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "two",
  data() {
    return {
      datavalue:"",
      // 料号
      fuzzyRecom:"",
      // 商品名称
      orderNo:"",
      // 时间
      TimeValue:"",
      form: {
        name1: "",
        name2: "",
        name3: ""
      },
      value3: "",
      //   表格 数据
       tableData: [
        {
          id: "1",
          name: "王小虎1",
          address: "上海市普陀区金沙江2323路 "
        },
        {
          id: "2",
          name: "王小虎2",
          address: "上海市普陀区金沙江路2323 弄"
        },
        {
          id: "3",
          name: "王小虎3",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          id: "4",
          name: "王小虎4",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      //
      currentPage4: 4
    };
  },
  methods:{
  
    //  本期入库处理函数
    aaa(item){
      console.log(item.id)
    },
    // 本期出库 处理函数
    bbb(item){
      console.log(item.name)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.tableone {
  padding: 0 50px;
}
.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}



</style>



// WEBPACK FOOTER //
// src/components/OrderManage/summary .vue